import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {AuthService} from "@core-services/auth.service";

export const loginGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (authService.isAuthenticated()) {
        router.navigate(['/']).then(() => console.info('Navigate to home.')
        );
        return false;
    }
    console.info('Navigate to auth/login.');
    return true;
};